<template>
  <h2>404 Not found</h2>
</template>
<script>
export default {
  name: 'Err404View'
}
</script>
